import type {
  Address,
  AddressEntry,
  OrganizationAddressLabels,
} from "../model/Address";
import API, { responseOf } from "./base";

export const createWithEntry = (
  address: Address,
  addressEntry: AddressEntry,
): Promise<Address> =>
  responseOf(API.post("/address/create", { addressEntry, address }));

export const create = (
  address: Address,
  organization_id: string,
  label: OrganizationAddressLabels,
  user_id = "",
): Promise<Address> =>
  responseOf(
    API.post("/address/create", {
      addressEntry: {
        organization_id,
        user_id,
        address_id: "",
        label,
        id: "",
      },
      address,
    }),
  );

export const getAddressById = (address_id: string): Promise<Address> =>
  responseOf(API.get(`/address/${address_id}`));

// Gives both org user and global addresses
export const getAllOrganizationAddressEntries = (
  organization_id: string,
): Promise<AddressEntry[]> =>
  responseOf(API.get(`/address/organization/${organization_id}/all`));

export const getGlobalOrganizationAddresses = (
  organization_id: string,
): Promise<AddressEntry[]> =>
  responseOf(API.get(`/address/organization/${organization_id}`));

export const getOrganizationAddressEntriesByLabel = (
  organization_id: string,
  label: OrganizationAddressLabels,
): Promise<AddressEntry[]> =>
  responseOf(
    API.get(`/address/organization/${organization_id}/label/${label}`),
  );

export const getOrganizationUserAddresses = (
  organization_id: string,
  user_id: string,
): Promise<AddressEntry[]> =>
  responseOf(
    API.get(`/address/organization/${organization_id}/user/${user_id}`),
  );

export const getOrganizationAddressByLabel = (
  organization_id: string,
  label: OrganizationAddressLabels,
): Promise<Address | null> =>
  responseOf(
    API.get(
      `/address/organization/${organization_id}/label/${label.toString()}/address`,
    ),
  );

export const remove = (addressId: string): Promise<string> =>
  responseOf(API.delete(`/address/${addressId}`));

export const update = (addressId: string, address: Address): Promise<Address> =>
  responseOf(API.post(`/address/update/${addressId}`, address));
